import AbstractEnumSelect from "../AbstractEnumSelect";

const RoleSelect = ({customOnChange, roles, allowMultiple, disabled, value, onChange, loading}) => {

    return <AbstractEnumSelect
        onChange={customOnChange}
        enums={roles}
        enumName="Taux"
        allowMultiple={allowMultiple}
        disabled={disabled}
        antValue={value}
        antOnChange={onChange}
        loading={loading}
    />;
}

export default RoleSelect;
